
<div class="loading">
    
    <span class="mat-body-1" style="margin-top: 20px">
        {{ text }}
    </span>

</div>